define.alias("shared/components/shared/wizard/next-button", "preview-grid/components/shared/wizard/next-button");